import taxTables from "./tax-tables";
import municipalities from "./municipalities";
export class Taxation {
    constructor(retirementAge) {
        this.highIncomeThreshold = 80000;
        this.retirementAge = retirementAge;
    }
    /**
     * Determines if tax payer is retired due to age
     *
     * @param age Tax payer age
     * @returns True if retired, otherwise false
     */
    isOfRetirementAge(age) {
        return age >= this.retirementAge;
    }
    isHighIncome(income) {
        return income > this.highIncomeThreshold;
    }
    incomeTax(income, value) {
        let tax;
        if (this.isHighIncome(income)) {
            tax = Math.round(income * (value / 100));
        }
        else {
            tax = value;
        }
        return tax;
    }
    /**
     * Calculates income after tax for worker or retired person
     *
     * @param income Monthly gross income before tax
     * @param age Tax payer age
     * @param taxTable tax table
     * @returns Net income
     */
    netIncome(income, age, taxTable = 32) {
        const roundedIncome = Math.ceil(income);
        const { v: value, r: retirement } = taxTables.find(({ tt, fr, to }) => tt === taxTable && roundedIncome >= fr && roundedIncome <= to) || {
            v: 0,
            r: 0,
        };
        let tax;
        if (this.isOfRetirementAge(age)) {
            tax = this.incomeTax(roundedIncome, retirement);
        }
        else {
            tax = this.incomeTax(roundedIncome, value);
        }
        return income - tax;
    }
}
/**
 * Getter for swedish municipalities and their tax table number
 *
 * @returns List of swedish municipalities with their tax table number
 */
export function getMunicipalities() {
    return municipalities;
}
